// extracted by mini-css-extract-plugin
export default {"Levels":"levels_Levels__oR7oL","level":"levels_level__TQpIo","lock":"levels_lock__bUJmX"};